export default __webpack_public_path__ + "static/media/logo-tender.a09c4e85.svg";